import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'requiredMessage'
})
export class RequiredMessagePipe implements PipeTransform {

  requiredMsg = '';
  constructor(private translate: TranslateService) {
    this.translate.get('Common.RequiredMessage').subscribe(trans => {
      this.requiredMsg = trans;
    });
  }

  // transform(value: unknown, ...args: unknown[]): unknown {
  //   if (this.translate.currentLang == "en") {
  //     return `${value}${this.requiredMsg}`
  //   }
  //   else {
  //     return `${value}${this.requiredMsg}`
  //   }

  // }

  transform(value: unknown, ...args: unknown[]): unknown {
    if (this.translate.currentLang == "en") {
      return `${this.requiredMsg}`
    }
    else {
      return `${this.requiredMsg}`
    }

  }
}
